import StoreCommon from '@/app-core/mixins/store/storeCommon'
import {toLocaleUpperCase} from '@/app-core/lib/helpers'

export default {
  name      : 'StoreCard',
  components: {},
  directives: {},
  mixins    : [StoreCommon],
  props     : {
    item: {
      type   : Object,
      default: undefined
    },

    to: {
      type   : Object,
      default: undefined
    },

    hover: {
      type   : Boolean,
      default: false
    },

    dense: {
      type   : Boolean,
      default: false
    },

    disabled: {
      type   : Boolean,
      default: false
    },

    gradient: {
      type   : String,
      default: 'to top, rgba(0,0,0,0), rgba(0,0,0,.5)'
    }

  },
  enums: {},
  data() {
    return {}
  },
  computed: {},
  watch   : {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    toLocaleUpperCase
  }
}
